import { render, staticRenderFns } from "./ShowItem.vue?vue&type=template&id=3910eb7a&scoped=true&"
import script from "./ShowItem.vue?vue&type=script&lang=js&"
export * from "./ShowItem.vue?vue&type=script&lang=js&"
import style1 from "./ShowItem.vue?vue&type=style&index=1&id=3910eb7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3910eb7a",
  null
  
)

export default component.exports